(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oshibori-order-form"] && !Shopify.designMode) return;
  try {
    
  (function(){
    'use strict';

    document.querySelectorAll('[data-section-type="oshibori-order-form"]').forEach(initSection);

    function initSection(root){
      var rows = Array.from(root.querySelectorAll('[data-row]'));
      if (!rows.length) return;

      var foot = {
        row:     root.querySelector('[data-foot-row]'),
        total:   root.querySelector('[data-foot-total]'),
        cartons: root.querySelector('[data-foot-cartons]'),
        towels:  root.querySelector('[data-foot-towels]')
      };

      var mobileBar = {
        el:        root.querySelector('[data-mobile-bar]'),
        count:     root.querySelector('[data-mob-count]'),
        total:     root.querySelector('[data-mob-total]'),
        scrollBtn: root.querySelector('[data-mob-scroll]'),
        tier:      root.querySelector('[data-mob-tier]'),
        tierMsg:   root.querySelector('[data-mob-tier-msg]'),
        tierFill:  root.querySelector('[data-mob-tier-fill]')
      };

      var sidebar = {
        count:         root.querySelector('[data-sb-count]'),
        bigQty:        root.querySelector('[data-sb-big-qty]'),
        bigCartons:    root.querySelector('[data-sb-big-cartons]'),
        list:          root.querySelector('[data-sb-list]'),
        totalsBlock:   root.querySelector('[data-sb-totals]'),
        subtotal:      root.querySelector('[data-sb-subtotal]'),
        discountRow:   root.querySelector('[data-sb-discount-row]'),
        discountLabel: root.querySelector('[data-sb-discount-label]'),
        discountAmt:   root.querySelector('[data-sb-discount-amount]'),
        total:         root.querySelector('[data-sb-total]'),
        addBtn:        root.querySelector('[data-sb-add]'),
        toast:         root.querySelector('[data-sb-toast]'),
        tiers:         root.querySelector('[data-sb-tiers]')
      };

      var modal = {
        el:   root.querySelector('[data-modal]'),
        body: root.querySelector('[data-modal-body]'),
        data: root.querySelector('[data-modal-data]')
      };

      var fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

      // Parse tiers JSON sur chaque ligne
      rows.forEach(function(row){
        try { row._tiers = JSON.parse(row.dataset.tiers || '[]'); }
        catch(e){ row._tiers = []; }
        if (Array.isArray(row._tiers)) row._tiers.sort(function(a,b){ return a.q - b.q; });
        // Filet de securite : un palier dont le prix est < 50% du prix de base
        // est probablement une erreur de saisie (metafield mal parse). On l'ignore.
        var base = parseInt(row.dataset.baseUnitCents, 10) || 0;
        if (base > 0 && Array.isArray(row._tiers)) {
          var minAcceptable = Math.floor(base * 0.5);
          row._tiers = row._tiers.filter(function(t){
            return t && t.p >= minAcceptable;
          });
        }
      });

      rows.forEach(applyDluBadge);

      // Injecte le nom de couleur (Blanc/Noir/...) a cote de la pastille de gamme
      // → visible uniquement sur mobile via CSS (vue tableau compact)
      rows.forEach(function(row){
        var colGroup = row.querySelector('.col-group');
        var label = row.dataset.colorLabel || '';
        if (colGroup && label && !colGroup.querySelector('.osh-color-name')) {
          var span = document.createElement('span');
          span.className = 'osh-color-name';
          span.textContent = label;
          colGroup.appendChild(span);
        }
      });
      rows.forEach(function(row){ updatePriceCell(row, 0); });

      initFilters(root, rows);
      initSteppers(rows);
      initRowClick();
      initModalClose();
      root.querySelectorAll('[data-order-table]').forEach(initColumnHover);
      initCatalogue();
      initViewToggle();

      if (sidebar.addBtn) sidebar.addBtn.addEventListener('click', handleAddToCart);
      // Sticky bar mobile : tap "Voir ma sélection" scrolle vers la sidebar
      if (mobileBar.scrollBtn) {
        mobileBar.scrollBtn.addEventListener('click', function(){
          var target = root.querySelector('[data-sidebar]') || sidebar.addBtn;
          if (target && typeof target.scrollIntoView === 'function') {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }

      recompute();

      // ============================================================
      function applyDluBadge(row){
        var cell = row.querySelector('[data-dlu-cell]');
        var val = (row.dataset.expiry || '').trim();
        if (!val || val.indexOf('/') === -1) {
          row.dataset.monthsLeft = '999';
          if (cell) cell.innerHTML = '<span class="osh-dlu-neutral">—</span>';
          return;
        }
        var parts = val.split('/');
        var expiry = new Date(parseInt(parts[1], 10), parseInt(parts[0], 10) - 1, 1);
        var today = new Date();
        var monthsLeft = (expiry.getFullYear() - today.getFullYear()) * 12
                       + (expiry.getMonth() - today.getMonth());
        row.dataset.monthsLeft = String(monthsLeft);

        if (!cell) return;
        if (monthsLeft < 3) {
          cell.innerHTML = '<span class="osh-dlu-badge osh-dlu-badge--red">' + val + '</span>';
        } else if (monthsLeft <= 6) {
          cell.innerHTML = '<span class="osh-dlu-badge osh-dlu-badge--orange">' + val + '</span>';
        } else {
          cell.innerHTML = '<span class="osh-dlu-neutral">' + val + '</span>';
        }
      }

      // Renvoie le prix unitaire applicable (en cents) selon qty serviettes
      // Base = variant.price / pack_size. Un palier n'override que s'il est INFERIEUR au base.
      function unitPriceFor(row, qty){
        var base = parseInt(row.dataset.baseUnitCents, 10) || 0;
        if (qty <= 0) return base;
        var tiers = row._tiers || [];
        var bestPrice = base;
        for (var i = 0; i < tiers.length; i++) {
          var t = tiers[i];
          if (t && t.p > 0 && qty >= t.q && t.p < bestPrice) {
            bestPrice = t.p;
          }
        }
        return bestPrice;
      }

      // Renvoie le prochain palier qui offre une reduction reelle, ou null
      function nextTierFor(row, qty){
        var current = unitPriceFor(row, qty);
        var tiers = row._tiers || [];
        for (var i = 0; i < tiers.length; i++) {
          var t = tiers[i];
          if (t && t.p > 0 && qty < t.q && t.p < current) return t;
        }
        return null;
      }

      function updatePriceCell(row, qty){
        var cell = row.querySelector('[data-price-cell]');
        if (!cell) return;
        var nowEl = cell.querySelector('[data-price-now]');
        var nextEl = cell.querySelector('[data-price-next]');
        var unitC = unitPriceFor(row, qty);

        // Flash vert si on vient de franchir un palier (prix qui baisse)
        var prev = row._lastUnitC;
        if (typeof prev === 'number' && unitC < prev) {
          row.setAttribute('data-tier-flash', '');
          setTimeout(function(){ row.removeAttribute('data-tier-flash'); }, 700);
        }
        row._lastUnitC = unitC;

        var euros = (unitC / 100);
        if (nowEl) nowEl.textContent = euros.toFixed(2).replace('.', ',') + ' €';

        // Active = pas le tier de base
        var tiers = row._tiers || [];
        if (tiers.length && unitC < tiers[0].p) {
          cell.setAttribute('data-tier-active', '');
        } else {
          cell.removeAttribute('data-tier-active');
        }

        // Hint prochain palier
        if (nextEl) {
          var nx = nextTierFor(row, qty);
          if (nx && qty > 0) {
            var remaining = nx.q - qty;
            nextEl.textContent = '+' + remaining + ' u → ' + (nx.p / 100).toFixed(2).replace('.', ',') + ' €';
          } else {
            nextEl.textContent = '';
          }
        }
      }

      // Decompose qty en (n masters + n petits cartons)
      function splitCartons(qty, pack, master){
        if (qty <= 0) return { masters: 0, units: 0, label: '' };
        var masters = Math.floor(qty / master);
        var remainder = qty - masters * master;
        var units = Math.round(remainder / pack);
        var parts = [];
        if (masters > 0) parts.push(masters + ' carton' + (masters>1?'s':'') + ' de ' + master);
        if (units > 0)   parts.push(units + ' carton' + (units>1?'s':'') + ' de ' + pack);
        return { masters: masters, units: units, label: parts.join(' + ') };
      }

      function initSteppers(rows){
        rows.forEach(function(row){
          var stepper = row.querySelector('[data-stepper]');
          var input   = row.querySelector('[data-qty-input]');
          if (!stepper || !input) return;

          // Empeche le clic stepper de propager vers la ligne (qui ouvre la modale)
          stepper.addEventListener('click', function(e){ e.stopPropagation(); });
          input.addEventListener('click', function(e){ e.stopPropagation(); });
          input.addEventListener('focus', function(e){ e.stopPropagation(); });

          // Le stepper compte en CARTONS : -1 / +1 par clic
          stepper.querySelectorAll('[data-step]').forEach(function(btn){
            btn.addEventListener('click', function(){
              var dir = parseInt(btn.dataset.step, 10);
              var cur = parseInt(input.value, 10) || 0;
              var next = cur + dir;
              if (next < 0) next = 0;
              input.value = next;
              recompute();
            });
          });

          input.addEventListener('blur', function(){
            var v = parseInt(input.value, 10);
            if (isNaN(v) || v < 0) v = 0;
            input.value = v;
            recompute();
          });
          input.addEventListener('input', recompute);
        });
      }

      function initRowClick(){
        rows.forEach(function(row){
          row.addEventListener('click', function(e){
            // Si on a cliqué dans le stepper, ignore
            if (e.target.closest('[data-stepper]')) return;
            openModalFor(row);
          });
          row.addEventListener('keydown', function(e){
            if (e.key === 'Enter' || e.key === ' ') {
              if (e.target.closest('[data-stepper]')) return;
              e.preventDefault();
              openModalFor(row);
            }
          });
        });
      }

      // Etat actif de la modale : ligne actuellement liee
      var activeModalRow = null;

      function openModalFor(row){
        if (!modal.el || !modal.body || !modal.data) return;
        var blockId = row.dataset.blockId;
        var tpl = modal.data.querySelector('template[data-block-id="' + blockId + '"]');
        if (!tpl) return;
        modal.body.innerHTML = '';
        modal.body.appendChild(tpl.content.cloneNode(true));
        activeModalRow = row;

        // Pastilles : Grammage (osh-pill du tableau) + Senteur + Packaging
        var chipsEl = modal.body.querySelector('[data-modal-chips]');
        if (chipsEl) {
          var groupKey   = row.dataset.group || '';
          var gammeLabel = row.dataset.groupLabel || '';
          var colorLabel = row.dataset.colorLabel || '';
          // Senteur : lue depuis la cellule Parfum de la ligne du tableau
          var senteurCell = row.querySelector('.col-fragrance');
          var senteurLabel = senteurCell ? senteurCell.textContent.trim() : '';

          chipsEl.innerHTML = '';
          if (gammeLabel) {
            var c1 = document.createElement('span');
            c1.className = 'osh-pill osh-pill--' + groupKey;
            c1.textContent = gammeLabel;
            chipsEl.appendChild(c1);
          }
          if (senteurLabel && senteurLabel !== '—') {
            var c2 = document.createElement('span');
            c2.className = 'osh-modal__chip';
            c2.textContent = senteurLabel;
            chipsEl.appendChild(c2);
          }
          if (colorLabel) {
            var c3 = document.createElement('span');
            c3.className = 'osh-modal__chip';
            c3.textContent = colorLabel;
            chipsEl.appendChild(c3);
          }
        }

        // Zone quantite : reutilise les classes osh-stepper du tableau
        var qtyZone = modal.body.querySelector('[data-modal-qty-zone]');
        if (qtyZone) {
          var rowInput = row.querySelector('[data-qty-input]');
          var currentCartons = parseInt(rowInput.value, 10) || 0;
          qtyZone.innerHTML =
            '<div class="osh-modal__qty">' +
              '<div class="osh-modal__qty-row">' +
                '<div class="osh-modal__qty-left">' +
                  '<div class="osh-stepper">' +
                    '<button type="button" class="osh-stepper__btn" data-modal-step="-1" aria-label="Diminuer">' +
                      '<svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M5 11h14v2H5z"/></svg>' +
                    '</button>' +
                    '<input type="number" class="osh-stepper__input" value="' + currentCartons + '" min="0" step="1" inputmode="numeric" data-modal-qty>' +
                    '<button type="button" class="osh-stepper__btn" data-modal-step="1" aria-label="Augmenter">' +
                      '<svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z"/></svg>' +
                    '</button>' +
                  '</div>' +
                  '<span class="osh-modal__qty-label">cartons</span>' +
                '</div>' +
                '<div class="osh-modal__qty-totals">' +
                  '<span class="osh-modal__qty-units" data-modal-units>0 unité</span>' +
                  '<span class="osh-modal__qty-amount" data-modal-amount>0,00 €</span>' +
                  '<span class="osh-modal__qty-split" data-modal-split></span>' +
                '</div>' +
                '<button type="button" class="button button--primary osh-modal__add" data-modal-add>Ajouter</button>' +
              '</div>' +
            '</div>';

          // Lie les boutons modale -> input du tableau
          qtyZone.querySelectorAll('[data-modal-step]').forEach(function(btn){
            btn.addEventListener('click', function(){
              var dir = parseInt(btn.dataset.modalStep, 10);
              var cur = parseInt(rowInput.value, 10) || 0;
              var next = cur + dir;
              if (next < 0) next = 0;
              rowInput.value = next;
              recompute();
            });
          });
          var modalInput = qtyZone.querySelector('[data-modal-qty]');
          modalInput.addEventListener('input', function(){
            var v = parseInt(modalInput.value, 10);
            if (isNaN(v) || v < 0) v = 0;
            rowInput.value = v;
            recompute();
          });
          // Bouton "Ajouter" : la qte est deja dans la selection,
          // ce bouton ferme simplement la modale (UX de confirmation).
          var addBtn = qtyZone.querySelector('[data-modal-add]');
          if (addBtn) addBtn.addEventListener('click', closeModal);
        }

        // Premiere maj de l'affichage
        refreshModalDisplay();

        modal.el.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      // Met a jour la modale (qty input, unites, sous-total, palier actif)
      // en fonction de l'etat courant de la ligne liee.
      function refreshModalDisplay(){
        if (!activeModalRow || modal.el.hidden) return;
        var row = activeModalRow;
        var rowInput = row.querySelector('[data-qty-input]');
        var cartons = parseInt(rowInput.value, 10) || 0;
        var pack = parseInt(row.dataset.packSize, 10) || 50;
        var serviettes = cartons * pack;
        var baseC = parseInt(row.dataset.baseUnitCents, 10) || 0;

        // Recalcule le prix unitaire courant pour la gamme
        var group = row.dataset.group || 'other';
        var groupQty = 0;
        rows.forEach(function(r){
          if ((r.dataset.group || 'other') === group) {
            var c = parseInt(r.querySelector('[data-qty-input]').value, 10) || 0;
            var p = parseInt(r.dataset.packSize, 10) || 50;
            groupQty += c * p;
          }
        });
        var unitC = unitPriceFor(row, groupQty);
        var subtotal = serviettes * unitC;

        // Maj stepper qty input dans la modale
        var modalInput = modal.body.querySelector('[data-modal-qty]');
        if (modalInput && parseInt(modalInput.value, 10) !== cartons) {
          modalInput.value = cartons;
        }

        // Unites
        var unitsEl = modal.body.querySelector('[data-modal-units]');
        if (unitsEl) unitsEl.textContent = serviettes + ' Oshibori';

        // Sous-total
        var amtEl = modal.body.querySelector('[data-modal-amount]');
        if (amtEl) amtEl.textContent = fmt.format(subtotal / 100);

        // Decomposition des cartons (1 master 300 + 2 cartons 50, etc.)
        // Pour 6g : master 600 / unite 100 ; pour les autres : 300 / 50
        var master = parseInt(row.dataset.masterSize, 10) || 300;
        var split = splitCartons(serviettes, pack, master);
        var splitEl = modal.body.querySelector('[data-modal-split]');
        if (splitEl) splitEl.textContent = split.label ? '= ' + split.label : '';

        // Surligne le palier actif (le plus haut atteint par groupQty)
        // Cible les <tr> du tableau de paliers via leur attribut data-tier-q
        var tiers = modal.body.querySelectorAll('[data-tier-q]');
        var activeIdx = -1;
        tiers.forEach(function(t, idx){
          var tq = parseInt(t.dataset.tierQ, 10) || 0;
          if (groupQty >= tq && tq > 0) activeIdx = idx;
          t.classList.remove('is-active');
        });
        if (activeIdx >= 0 && tiers[activeIdx]) tiers[activeIdx].classList.add('is-active');
      }

      function initModalClose(){
        if (!modal.el) return;
        modal.el.querySelectorAll('[data-modal-close]').forEach(function(el){
          el.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function(e){
          if (e.key === 'Escape' && !modal.el.hidden) closeModal();
        });
      }

      function closeModal(){
        modal.el.hidden = true;
        document.body.style.overflow = '';
        activeModalRow = null;
      }

      function recompute(){
        // 1er passage : totaux par gamme (en serviettes : cartons × pack)
        var groupTotals = {};
        rows.forEach(function(row){
          var input = row.querySelector('[data-qty-input]');
          var cartons = parseInt(input.value, 10) || 0;
          var pack = parseInt(row.dataset.packSize, 10) || 50;
          var group = row.dataset.group || 'other';
          groupTotals[group] = (groupTotals[group] || 0) + (cartons * pack);
        });

        // 2eme passage : prix par ligne base sur le total de gamme
        var totalTowels = 0, totalCartons = 0, totalAmount = 0, baseSubtotal = 0;
        var activeRows = [];

        rows.forEach(function(row){
          var input    = row.querySelector('[data-qty-input]');
          var cartons  = parseInt(input.value, 10) || 0;
          var pack     = parseInt(row.dataset.packSize, 10) || 50;
          var master   = parseInt(row.dataset.masterSize, 10) || 300;
          var group    = row.dataset.group || 'other';
          var groupQty = groupTotals[group] || 0;
          var baseC    = parseInt(row.dataset.baseUnitCents, 10) || 0;

          var serviettes = cartons * pack;

          // Prix unitaire dynamique : palier declenche par le total de gamme
          updatePriceCell(row, groupQty);
          var unitC = unitPriceFor(row, groupQty);

          var subtotal = serviettes * unitC;
          var baseRow  = serviettes * baseC;

          var split = splitCartons(serviettes, pack, master);
          var meta = row.querySelector('[data-stepper-meta]');
          if (meta) meta.textContent = serviettes > 0 ? ('= ' + split.label) : '';

          // Cellule Unites (nb d'oshiboris pour cette ligne)
          var unitsCell = row.querySelector('[data-cell-units]');
          if (unitsCell) unitsCell.textContent = serviettes > 0 ? serviettes : '—';

          // Cellule Sous-total HT (par ligne)
          var subCell = row.querySelector('[data-cell-subtotal]');
          if (subCell) subCell.textContent = serviettes > 0 ? fmt.format(subtotal / 100) : '—';

          // Synchro stepper + unites Catalogue si present
          if (row._catInput && parseInt(row._catInput.value, 10) !== cartons) {
            row._catInput.value = cartons;
          }
          if (row._catUnits) {
            row._catUnits.textContent = serviettes > 0 ? (serviettes + ' Oshibori') : '—';
          }

          if (cartons > 0) {
            totalTowels  += serviettes;
            totalCartons += cartons;
            totalAmount  += subtotal;
            baseSubtotal += baseRow;
            activeRows.push({
              row: row, qty: serviettes, groupQty: groupQty, cartons: cartons,
              subtotal: subtotal, split: split, unitCents: unitC, baseCents: baseC
            });
          }
        });

        // Pied du tableau (sous-total global)
        if (foot.row) {
          if (activeRows.length) {
            foot.row.hidden = false;
            if (foot.total)   foot.total.textContent   = fmt.format(totalAmount / 100);
            if (foot.cartons) foot.cartons.textContent = totalCartons;
            if (foot.towels)  foot.towels.textContent  = totalTowels;
          } else {
            foot.row.hidden = true;
          }
        }

        updateSidebar(activeRows, totalTowels, totalCartons, totalAmount, baseSubtotal, groupTotals);

        // Met a jour la modale si ouverte (synchro temps reel)
        refreshModalDisplay();
      }

      function updateSidebar(activeRows, totalTowels, totalCartons, totalAmount, baseSubtotal, groupTotals){
        if (!sidebar.list) return;
        if (sidebar.count)  sidebar.count.textContent  = activeRows.length + ' réf.';
        if (sidebar.bigQty)     sidebar.bigQty.textContent     = totalTowels;
        if (sidebar.bigCartons) sidebar.bigCartons.textContent = totalCartons + ' carton' + (totalCartons > 1 ? 's' : '');

        // Sticky bar mobile : update + show/hide
        if (mobileBar.el) {
          var hasItems = activeRows.length > 0;
          if (mobileBar.count) {
            mobileBar.count.textContent = totalCartons + ' carton' + (totalCartons > 1 ? 's' : '') + ' · ' + totalTowels + ' Oshibori';
          }
          if (mobileBar.total) mobileBar.total.textContent = fmt.format(totalAmount / 100);
          if (mobileBar.scrollBtn) mobileBar.scrollBtn.disabled = !hasItems;
          if (hasItems) {
            mobileBar.el.hidden = false;
            requestAnimationFrame(function(){ mobileBar.el.classList.add('is-visible'); });
          } else {
            mobileBar.el.classList.remove('is-visible');
            setTimeout(function(){
              if (!mobileBar.el.classList.contains('is-visible')) mobileBar.el.hidden = true;
            }, 350);
          }
        }

        // Liste compacte
        sidebar.list.innerHTML = '';
        if (!activeRows.length) {
          var li = document.createElement('li');
          li.className = 'osh-sidebar__empty';
          li.textContent = 'Aucune référence sélectionnée pour le moment.';
          sidebar.list.appendChild(li);
          if (sidebar.totalsBlock) sidebar.totalsBlock.hidden = true;
          if (sidebar.addBtn) sidebar.addBtn.disabled = true;
          if (sidebar.tiers) { sidebar.tiers.hidden = true; sidebar.tiers.innerHTML = ''; }
          return;
        }

        activeRows.forEach(function(item){
          var r = item.row;
          var gammeLabel = r.dataset.groupLabel || r.dataset.group || '';
          var colorLabel = r.dataset.colorLabel || '';
          var colorHex = r.dataset.colorHex || '#f5f5f5';
          var colorStyle = r.dataset.colorStyle || 'solid';
          var colorKey = r.dataset.colorKey || '';
          var ml = parseInt(r.dataset.monthsLeft, 10);
          var expiry = r.dataset.expiry;

          var li = document.createElement('li');

          var swatch = document.createElement('span');
          var swCls = 'osh-sidebar__item-swatch';
          if (colorStyle === 'hatched') swCls += ' osh-sidebar__item-swatch--hatched';
          if (colorKey) swCls += ' osh-sidebar__item-swatch--' + colorKey;
          swatch.className = swCls;
          swatch.style.setProperty('--swatch', colorHex);
          li.appendChild(swatch);

          var label = document.createElement('span');
          label.className = 'osh-sidebar__item-label';
          label.innerHTML = escapeHtml(gammeLabel) + ' · ' + escapeHtml(colorLabel)
            + '<span class="osh-sidebar__item-cartons">× ' + item.cartons + '</span>';
          li.appendChild(label);

          var price = document.createElement('span');
          price.className = 'osh-sidebar__item-price';
          price.textContent = fmt.format(item.subtotal / 100);
          li.appendChild(price);

          if (!isNaN(ml) && ml < 3 && expiry) {
            var warn = document.createElement('span');
            warn.className = 'osh-sidebar__item-dlu';
            warn.textContent = '⚠ DLU : ' + expiry;
            li.appendChild(warn);
          }

          sidebar.list.appendChild(li);
        });

        // Totaux : sous-total, remise (si applicable), total
        if (sidebar.totalsBlock) sidebar.totalsBlock.hidden = false;
        if (sidebar.subtotal) sidebar.subtotal.textContent = fmt.format(baseSubtotal / 100);
        if (sidebar.total)    sidebar.total.textContent    = fmt.format(totalAmount / 100);

        var discount = baseSubtotal - totalAmount;
        if (discount > 0 && sidebar.discountRow) {
          sidebar.discountRow.hidden = false;
          var pct = baseSubtotal > 0 ? Math.round((discount / baseSubtotal) * 100) : 0;
          if (sidebar.discountLabel) sidebar.discountLabel.textContent = 'Remise volume · −' + pct + ' %';
          if (sidebar.discountAmt)   sidebar.discountAmt.textContent = '− ' + fmt.format(discount / 100);
        } else if (sidebar.discountRow) {
          sidebar.discountRow.hidden = true;
        }

        if (sidebar.addBtn) sidebar.addBtn.disabled = false;
        updateGlobalTier(activeRows, groupTotals);
      }

      // Libelles humains pour les gammes
      function groupLabelFor(g){
        if (g === '15g') return '15 grammes';
        if (g === '10g') return '10 grammes';
        if (g === '6g')  return '6 grammes';
        if (g === 'bambou') return 'Bambou';
        return g;
      }

      // Sliders de paliers : une carte par gamme active qui a un palier rentable
      // a venir. Ordre : gammes les plus proches du prochain palier en premier.
      function updateGlobalTier(activeRows, groupTotals){
        if (!sidebar.tiers) return;
        groupTotals = groupTotals || {};

        // Map gamme -> { base de ref, paliers de remise, qty cumulee }
        var groupsInfo = {};
        activeRows.forEach(function(item){
          var row = item.row;
          var g = row.dataset.group;
          if (groupsInfo[g]) return;
          var base = parseInt(row.dataset.baseUnitCents, 10) || 0;
          var allTiers = row._tiers || [];
          var discountTiers = allTiers.filter(function(t){
            return t && t.p > 0 && t.p < base;
          });
          groupsInfo[g] = {
            base: base, tiers: discountTiers, allTiers: allTiers,
            qty: groupTotals[g] || 0, label: groupLabelFor(g)
          };
        });

        // Construit la liste des cartes a afficher
        var cards = [];
        Object.keys(groupsInfo).forEach(function(g){
          var info = groupsInfo[g];
          if (!info.tiers.length) return;
          var qty = info.qty;
          var nx = null;
          for (var i = 0; i < info.tiers.length; i++) {
            if (qty < info.tiers[i].q) { nx = info.tiers[i]; break; }
          }
          if (!nx) return;
          var currentUnit = info.base;
          for (var k = 0; k < info.tiers.length; k++) {
            if (qty >= info.tiers[k].q && info.tiers[k].p < currentUnit) {
              currentUnit = info.tiers[k].p;
            }
          }
          var remaining = nx.q - qty;
          var savings = (currentUnit - nx.p) * nx.q;
          if (savings <= 0) return;
          cards.push({
            group: g, label: info.label, qty: qty, remaining: remaining,
            savings: savings, nx: nx, currentUnit: currentUnit,
            base: info.base, tiers: info.tiers, allTiers: info.allTiers
          });
        });

        if (!cards.length) {
          sidebar.tiers.hidden = true;
          sidebar.tiers.innerHTML = '';
          updateMobileBarTier(null);   // cache aussi la sticky bar tier
          return;
        }

        // Tri : gamme la plus proche du prochain palier en premier
        cards.sort(function(a, b){ return a.remaining - b.remaining; });

        sidebar.tiers.hidden = false;
        sidebar.tiers.innerHTML = '';
        cards.forEach(function(card){
          sidebar.tiers.appendChild(buildTierCard(card));
        });

        // Sticky bar mobile : alimentee avec le premier card (le plus proche)
        updateMobileBarTier(cards[0]);
      }

      // Alimente la zone tier de la barre sticky mobile depuis la carte la
      // plus proche d'un palier rentable. card === null => cache.
      function updateMobileBarTier(card){
        if (!mobileBar.tier) return;
        if (!card) { mobileBar.tier.hidden = true; return; }
        mobileBar.tier.hidden = false;
        var savingsFmt = fmt.format(card.savings / 100);
        var pctDiscount = card.base > 0 ? Math.round((1 - card.nx.p / card.base) * 100) : 0;
        if (mobileBar.tierMsg) {
          mobileBar.tierMsg.innerHTML =
            'Plus que <strong>' + card.remaining + ' Oshibori</strong> en '
            + escapeHtml(card.label)
            + ' pour <strong>−' + pctDiscount + ' %</strong> (économisez <strong>' + savingsFmt + '</strong>)';
        }
        if (mobileBar.tierFill) {
          var pct = Math.min(100, (card.qty / card.nx.q) * 100);
          mobileBar.tierFill.style.width = pct + '%';
        }
      }

      // Construit une carte de palier au design segmente (style screenshot)
      // Segments : 1 base (—) + 1 par tier de remise. Label sous chaque segment = % de remise.
      // Carte compacte : 1 ligne d'info + barre simple + tooltip avec tous les paliers
      function buildTierCard(card){
        var wrap = document.createElement('div');
        wrap.className = 'osh-tier-card';

        // Header : gamme + progression + bouton info
        var head = document.createElement('div');
        head.className = 'osh-tier-card__head';

        var title = document.createElement('span');
        title.className = 'osh-tier-card__title';
        title.textContent = card.label;
        head.appendChild(title);

        var progressText = document.createElement('span');
        progressText.className = 'osh-tier-card__progress';
        progressText.textContent = card.qty + ' / ' + card.nx.q;
        head.appendChild(progressText);

        // Bouton info + tooltip (paliers complets)
        var infoWrap = document.createElement('span');
        infoWrap.className = 'osh-tier-card__info-wrap';

        var infoBtn = document.createElement('button');
        infoBtn.type = 'button';
        infoBtn.className = 'osh-tier-card__info';
        infoBtn.setAttribute('aria-label', 'Voir tous les paliers');
        infoBtn.innerHTML =
          '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">' +
            '<path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>' +
          '</svg>';

        var tooltip = document.createElement('div');
        tooltip.className = 'osh-tier-card__tooltip';

        var tipTitle = document.createElement('div');
        tipTitle.className = 'osh-tier-card__tooltip-title';
        tipTitle.textContent = 'Paliers ' + card.label;
        tooltip.appendChild(tipTitle);

        var tierList = document.createElement('ul');
        tierList.className = 'osh-tier-card__tooltip-list';
        // Tous les paliers du produit (tableau brut depuis metafields)
        var allTiers = card.allTiers || [];
        // Determine le palier actif (le plus haut atteint par card.qty)
        var activeTierIdx = -1;
        for (var i = 0; i < allTiers.length; i++) {
          if (card.qty >= allTiers[i].q) activeTierIdx = i;
        }
        allTiers.forEach(function(t, idx){
          var li = document.createElement('li');
          if (idx === activeTierIdx) li.className = 'is-active';
          var priceFmt = (t.p / 100).toFixed(2).replace('.', ',') + ' €';
          li.innerHTML = '<span>' + t.q + '+</span><strong>' + priceFmt + '</strong>';
          tierList.appendChild(li);
        });
        tooltip.appendChild(tierList);

        infoWrap.appendChild(infoBtn);
        infoWrap.appendChild(tooltip);
        head.appendChild(infoWrap);

        // Toggle tooltip on click (mobile-friendly, complement le hover CSS)
        infoBtn.addEventListener('click', function(e){
          e.stopPropagation();
          infoWrap.classList.toggle('is-open');
        });
        document.addEventListener('click', function(){
          infoWrap.classList.remove('is-open');
        });

        wrap.appendChild(head);

        // Barre de progression simple
        var bar = document.createElement('div');
        bar.className = 'osh-tier-card__bar';
        var fill = document.createElement('div');
        fill.className = 'osh-tier-card__bar-fill';
        var pct = Math.min(100, (card.qty / card.nx.q) * 100);
        fill.style.width = pct + '%';
        bar.appendChild(fill);
        wrap.appendChild(bar);

        // Message principal : economie en €
        var msg = document.createElement('p');
        msg.className = 'osh-tier-card__msg';
        var savingsFmt = fmt.format(card.savings / 100);
        msg.innerHTML = 'Encore <strong>' + card.remaining + ' Oshibori</strong> pour économiser <strong>' + savingsFmt + '</strong>';
        wrap.appendChild(msg);

        return wrap;
      }

      function handleAddToCart(){
        var items = [];
        rows.forEach(function(row){
          var input = row.querySelector('[data-qty-input]');
          var cartons = parseInt(input.value, 10) || 0;
          var varId = row.dataset.variantId;
          if (cartons > 0 && varId) {
            items.push({ id: parseInt(varId, 10), quantity: cartons });
          }
        });
        if (!items.length) return;

        sidebar.addBtn.disabled = true;
        sidebar.addBtn.textContent = 'Ajout en cours...';

        var redirectMode = (root.dataset.cartRedirect || 'stay').toLowerCase();

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(res){
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function(){
          // Si redirection demandee dans l'editeur, on part directement
          if (redirectMode === 'cart') { window.location.href = '/cart'; return null; }
          if (redirectMode === 'checkout') { window.location.href = '/checkout'; return null; }
          // Sinon on continue avec maj UI et drawer
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); });
        })
        .then(function(cart){
          if (!cart) return;   // cas redirect
          // 1) Maj directe des pastilles compteur les plus communes du theme
          var countSelectors = [
            '[data-cart-count]', '[data-cart-item-count]', '[data-header-cart-count]',
            '.cart-count', '.cart-count-bubble', '.cart-icon__bubble', '.cart-icon__count',
            '.header__cart-count', '.site-header__cart-count', '.js-cart-count'
          ];
          countSelectors.forEach(function(sel){
            document.querySelectorAll(sel).forEach(function(el){
              el.textContent = cart.item_count;
              if (el.dataset) el.dataset.count = cart.item_count;
              if (cart.item_count > 0) {
                el.hidden = false;
                el.style.removeProperty('display');
                el.classList.remove('hidden', 'is-empty');
                el.classList.add('has-items');
              }
            });
          });

          // 2) Notifie le theme via les events les plus utilises
          ['cart:added','cart:updated','cart:refresh','cart:change','cart-drawer:refresh','cart:item-added'].forEach(function(evt){
            document.dispatchEvent(new CustomEvent(evt, { detail: { cart: cart, source: 'oshibori-order-form' }, bubbles: true }));
          });

          // 3) Ouvre le cart drawer si present (UX : confirmation visible)
          var drawer = document.querySelector('cart-drawer, [is="cart-drawer"], #cart-drawer, .cart-drawer, [data-cart-drawer]');
          if (drawer) {
            if (typeof drawer.open === 'function') {
              try { drawer.open(); } catch(_){}
            } else if (drawer.classList && drawer.classList.contains('is-hidden') === false) {
              drawer.classList.add('is-active', 'is-open');
              drawer.setAttribute('open', '');
            } else {
              drawer.setAttribute('open', '');
              drawer.classList.add('is-active', 'is-open');
            }
          }

          // 4) Feedback bouton
          sidebar.addBtn.textContent = '✓ Ajoute au panier';
          sidebar.addBtn.classList.add('is-success');

          // Reset les steppers (la commande est partie dans le panier)
          rows.forEach(function(row){
            var inp = row.querySelector('[data-qty-input]');
            if (inp) inp.value = 0;
          });
          recompute();

          setTimeout(function(){
            sidebar.addBtn.textContent = 'Ajouter au panier';
            sidebar.addBtn.classList.remove('is-success');
            sidebar.addBtn.disabled = false;
          }, 2200);
        })
        .catch(function(err){
          console.error('[Oshibori] Ajout panier echoue', err);
          sidebar.addBtn.textContent = 'Erreur, reessayer';
          setTimeout(function(){
            sidebar.addBtn.textContent = 'Ajouter au panier';
            sidebar.addBtn.disabled = false;
          }, 2500);
        });
      }

      function escapeHtml(s){
        return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
                        .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
      }

      // ====== Vue Catalogue : construction des cartes a partir des lignes ======
      function initCatalogue(){
        rows.forEach(function(row){
          var groupKey = row.dataset.group;
          // Cherche le data-cat-grid du groupe correspondant
          var block;
          if (groupKey === 'bambou') {
            block = root.querySelector('[data-premium-block]');
          } else {
            block = root.querySelector('[data-group-block="' + groupKey + '"]');
          }
          if (!block) return;
          var grid = block.querySelector('[data-cat-grid]');
          if (!grid) return;
          var card = buildCatalogueCard(row);
          grid.appendChild(card);
        });
      }

      function buildCatalogueCard(row){
        var card = document.createElement('div');
        card.className = 'osh-cat-card';
        card.dataset.blockId = row.dataset.blockId;

        // Lecture des donnees depuis la ligne du tableau (source de verite)
        var img = row.querySelector('.col-img img');
        var heroSrc = img ? img.src : '';
        var compare = parseInt(row.dataset.compareAt, 10) || 0;
        var basePrice = parseInt(row.dataset.basePriceCents, 10) || 0;
        var pack = parseInt(row.dataset.packSize, 10) || 50;
        var groupKey = row.dataset.group || '';
        var groupLabel = row.dataset.groupLabel || '';
        var colorLabel = row.dataset.colorLabel || '';
        var colorKey = row.dataset.colorKey || '';
        var colorStyle = row.dataset.colorStyle || 'solid';
        var senteurCell = row.querySelector('.col-fragrance');
        var senteur = senteurCell ? senteurCell.textContent.trim() : '';
        var dluCell = row.querySelector('[data-dlu-cell]');
        var dluHTML = dluCell ? dluCell.innerHTML : '';
        var isPromo = compare > basePrice && compare > 0;
        var promoPct = isPromo ? Math.round((1 - basePrice / compare) * 100) : 0;

        // Promo badge
        if (isPromo) {
          var promo = document.createElement('span');
          promo.className = 'osh-cat-card__promo';
          promo.textContent = '− ' + promoPct + ' %';
          card.appendChild(promo);
        }

        // Hero : image (= colonne Packaging du tableau)
        var hero = document.createElement('div');
        hero.className = 'osh-cat-card__hero';
        if (heroSrc) {
          var heroImg = document.createElement('img');
          heroImg.src = heroSrc;
          heroImg.alt = row.dataset.name || '';
          heroImg.loading = 'lazy';
          heroImg.className = 'osh-cat-card__img';
          hero.appendChild(heroImg);
        } else {
          var placeholder = document.createElement('span');
          placeholder.className = 'osh-img-placeholder';
          hero.appendChild(placeholder);
        }
        card.appendChild(hero);

        // Body
        var body = document.createElement('div');
        body.className = 'osh-cat-card__body';

        // Ligne 1 : pastille gamme + badge DLU (cols Grammage + DLU du tableau)
        var topRow = document.createElement('div');
        topRow.className = 'osh-cat-card__row osh-cat-card__row--top';
        var gammePill = document.createElement('span');
        gammePill.className = 'osh-pill osh-pill--' + groupKey;
        gammePill.textContent = groupLabel;
        topRow.appendChild(gammePill);
        if (dluHTML) {
          var dluWrap = document.createElement('span');
          dluWrap.className = 'osh-cat-card__dlu';
          dluWrap.innerHTML = dluHTML;
          topRow.appendChild(dluWrap);
        }
        body.appendChild(topRow);

        // Ligne 2 : swatch + nom couleur (= col Packaging label du tableau)
        var colorRow = document.createElement('div');
        colorRow.className = 'osh-cat-card__color';
        var swatch = document.createElement('span');
        swatch.className = 'osh-swatch osh-swatch--' + colorKey + (colorStyle === 'hatched' ? ' osh-swatch--hatched' : '');
        swatch.style.setProperty('--swatch', row.dataset.colorHex || '#f5f5f5');
        colorRow.appendChild(swatch);
        var colorTxt = document.createElement('span');
        colorTxt.textContent = colorLabel;
        colorRow.appendChild(colorTxt);
        body.appendChild(colorRow);

        // Ligne 3 : Parfum (= col Parfum du tableau)
        var senteurEl = document.createElement('div');
        senteurEl.className = 'osh-cat-card__senteur';
        senteurEl.textContent = senteur;
        body.appendChild(senteurEl);

        // Ligne 4 : Conditionnement (= col Carton du tableau)
        var packEl = document.createElement('div');
        packEl.className = 'osh-cat-card__pack-info';
        packEl.textContent = '×' + pack + ' / carton';
        body.appendChild(packEl);

        // Ligne 5 : Prix unitaire (= col Prix HT/Oshibori du tableau)
        var price = document.createElement('div');
        price.className = 'osh-cat-card__price';
        var unitPrice = (basePrice / pack / 100).toFixed(2).replace('.', ',');
        var inner = '';
        if (isPromo) {
          var oldUnit = (compare / pack / 100).toFixed(2).replace('.', ',');
          inner = '<span class="osh-price-old">' + oldUnit + ' €</span> <strong>' + unitPrice + ' €</strong>';
        } else {
          inner = '<strong>' + unitPrice + ' €</strong>';
        }
        inner += ' <span class="osh-cat-card__price-suffix">/ Oshibori HT</span>';
        price.innerHTML = inner;
        body.appendChild(price);

        // Ligne 6 : Stepper (= col Cartons) + Unites (= col Unites)
        var qtyRow = document.createElement('div');
        qtyRow.className = 'osh-cat-card__qty';
        var rowInput = row.querySelector('[data-qty-input]');
        var currentCartons = parseInt(rowInput.value, 10) || 0;
        var currentUnits = currentCartons * pack;
        qtyRow.innerHTML =
          '<div class="osh-stepper">' +
            '<button type="button" class="osh-stepper__btn" data-cat-step="-1" aria-label="Diminuer">' +
              '<svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M5 11h14v2H5z"/></svg>' +
            '</button>' +
            '<input type="number" class="osh-stepper__input" value="' + currentCartons + '" min="0" step="1" inputmode="numeric" data-cat-qty>' +
            '<button type="button" class="osh-stepper__btn" data-cat-step="1" aria-label="Augmenter">' +
              '<svg viewBox="0 0 24 24" width="16" height="16"><path fill="currentColor" d="M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z"/></svg>' +
            '</button>' +
          '</div>' +
          '<span class="osh-cat-card__units" data-cat-units>' + (currentUnits > 0 ? currentUnits + ' Oshibori' : '—') + '</span>';
        body.appendChild(qtyRow);

        card.appendChild(body);

        // Lie le stepper de la carte au stepper de la ligne (source de verite)
        var catInput = qtyRow.querySelector('[data-cat-qty]');
        qtyRow.querySelectorAll('[data-cat-step]').forEach(function(btn){
          btn.addEventListener('click', function(){
            var dir = parseInt(btn.dataset.catStep, 10);
            var cur = parseInt(rowInput.value, 10) || 0;
            var next = cur + dir;
            if (next < 0) next = 0;
            rowInput.value = next;
            recompute();
          });
        });
        catInput.addEventListener('input', function(){
          var v = parseInt(catInput.value, 10);
          if (isNaN(v) || v < 0) v = 0;
          rowInput.value = v;
          recompute();
        });

        // Stocke les refs pour synchro inverse depuis recompute
        row._catInput = catInput;
        row._catUnits = qtyRow.querySelector('[data-cat-units]');

        return card;
      }

      // ====== Toggle Tableau / Catalogue ======
      function initViewToggle(){
        var toggle = root.querySelector('[data-view-toggle]');
        if (!toggle) return;
        // Utilise les classes du theme : .button (primaire = actif) et .button--secondary (inactif)
        toggle.querySelectorAll('[data-view]').forEach(function(btn){
          btn.addEventListener('click', function(){
            var view = btn.dataset.view;
            toggle.querySelectorAll('[data-view]').forEach(function(b){
              if (b === btn) b.classList.remove('button--secondary');
              else b.classList.add('button--secondary');
            });
            root.setAttribute('data-active-view', view);
          });
        });
        // Vue par defaut : tableau
        root.setAttribute('data-active-view', 'table');
      }

      // Highlight de colonne au survol de l'en-tete (uniquement desktop : on
      // skip si display:block sur les <tr> en mobile)
      function initColumnHover(table){
        if (!table) return;
        var ths = table.querySelectorAll('thead th');
        if (!ths.length) return;
        ths.forEach(function(th, idx){
          th.addEventListener('mouseenter', function(){ toggleCol(table, idx, true); });
          th.addEventListener('mouseleave', function(){ toggleCol(table, idx, false); });
        });
      }

      function toggleCol(table, idx, on){
        var th = table.querySelectorAll('thead th')[idx];
        if (th) th.classList.toggle('is-col-hover', on);
        // Cible toutes les lignes produit (tableau principal + bloc premium Bambou)
        root.querySelectorAll('tr.osh-row').forEach(function(tr){
          var td = tr.children[idx];
          if (td) td.classList.toggle('is-col-hover', on);
        });
      }
    }

    function initFilters(root, rows){
      var filterBtns = root.querySelectorAll('.osh-filter');
      if (!filterBtns.length) return;

      var counts = { all: 0, '15g': 0, '10g': 0, '6g': 0, bambou: 0 };
      rows.forEach(function(r){
        var g = r.dataset.group;
        counts.all++;
        if (counts[g] !== undefined) counts[g]++;
      });

      var setCount = function(key, val){
        var el = root.querySelector('[data-count-' + key + ']');
        if (el) el.textContent = val;
      };
      setCount('all', counts.all);
      setCount('15g', counts['15g']);
      setCount('10g', counts['10g']);
      setCount('6g', counts['6g']);
      setCount('bambou', counts.bambou);

      var refCount = root.querySelector('[data-refcount]');
      if (refCount) refCount.textContent = counts.all + ' reference' + (counts.all > 1 ? 's' : '');

      var emptyMsg = null;
      var groupBlocks = root.querySelectorAll('[data-group-block]');

      filterBtns.forEach(function(btn){
        btn.addEventListener('click', function(){
          var target = btn.dataset.filter;
          if (target === 'promo-short' && btn.classList.contains('is-active')) target = 'all';
          filterBtns.forEach(function(b){ b.classList.remove('is-active'); });
          var activate = Array.from(filterBtns).find(function(b){ return b.dataset.filter === target; });
          if (activate) activate.classList.add('is-active');
          applyFilter(target);
        });
      });

      function applyFilter(target){
        var visibleCount = 0;
        rows.forEach(function(row){
          var show = false;
          if (target === 'all') {
            show = true;
          } else if (target === 'promo-short') {
            var ml = parseInt(row.dataset.monthsLeft, 10);
            show = (row.dataset.promo === 'true') && !isNaN(ml) && ml <= 6;
          } else {
            show = row.dataset.group === target;
          }
          row.style.display = show ? '' : 'none';
          if (show) visibleCount++;
        });

        // Masque les blocs gamme (15g / 10g / 6g) sans ligne visible
        groupBlocks.forEach(function(gb){
          var grp = gb.dataset.groupBlock;
          var anyVisible = Array.from(gb.querySelectorAll('[data-row]'))
            .some(function(r){ return r.style.display !== 'none'; });
          gb.style.display = anyVisible ? '' : 'none';
        });

        // Bloc Premium : visible UNIQUEMENT si au moins une ligne premium passe le filtre
        var premiumBlock = root.querySelector('[data-premium-block]');
        if (premiumBlock) {
          if (target === 'all') {
            premiumBlock.style.display = '';
          } else {
            var visiblePremium = Array.from(premiumBlock.querySelectorAll('[data-row]'))
              .filter(function(r){ return r.style.display !== 'none'; });
            premiumBlock.style.display = visiblePremium.length > 0 ? '' : 'none';
          }
        }

        if (target === 'promo-short' && visibleCount === 0) {
          if (!emptyMsg) {
            emptyMsg = document.createElement('p');
            emptyMsg.className = 'oshibori-order__empty';
            emptyMsg.textContent = 'Aucune promotion avec date courte en ce moment.';
            // Insere apres le dernier bloc gamme ou apres le premium
            var anchor = groupBlocks[groupBlocks.length - 1] || premiumBlock;
            if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(emptyMsg, anchor.nextSibling);
          }
          emptyMsg.style.display = '';
        } else if (emptyMsg) {
          emptyMsg.style.display = 'none';
        }

        if (refCount) refCount.textContent = visibleCount + ' reference' + (visibleCount > 1 ? 's' : '');
      }
    }

  })();

  } catch(e) { console.error(e); }
})();
})();
